<template>
  <Listbox as="div" class="relative">
    <div v-if="show_results" class="btn cancel-btn absolute right-2 top-14 z-50 w-12 h-5 rounded-full" @click.stop="show_results = false">
      <span class="absolute">{{ $t("Close") }}</span>
    </div>
    <div class="flex mt-1 rounded-lg shadow-sm">
      <div class="relative flex items-stretch flex-grow focus-within:z-10">
        <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <Plus class="w-5 h-5 text-gray-400" aria-hidden="true" />
        </div>
        <input
          v-model="search_term"
          :disabled="disabled"
          autocomplete="off"
          :placeholder="translatedPlaceholder"
          type="text"
          :class="{ '!w-[400px]': shortKing }"
          class="focus:ring-blue dark:bg-dark-box-background dark:border-dark-divider-border transition-all ease-in-out duration-side-menu-transition-duration dark:text-dark-body-text dark:focus:border-dark-brand-blue focus:border-blue-light block w-[500px] disabled:bg-gray-200 rounded-md pl-10 sm:text-sm border-gray-300"
          @click="show_results = true"
          @blur="
            () => {
              // show_results = false
            }
          ">
      </div>

      <transition
        v-show="show_results"
        class="mt-10"
        leave-active-class="transition duration-100 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0">
        <ListboxOptions
          id="user-panel"
          static
          :class="['bg-light-screen-background dark:bg-dark-screen-background']"
          class="min-h-[180px] overflow-x-hidden absolute z-40 mt-1 w-full text-light-body-text dark:text-dark-body-text shadow-lg max-h-60 rounded-lg text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm transition ease-in-out duration-side-menu-transition-duration">
          <div as="template" class="relative cursor-pointer top-3 left-1">
            <span
              v-if="!hidePeopleTab"
              :class="[
                `p-2 border rounded-tl-md rounded-bl-md ${active_tab == 'team_members' ? 'bg-blue text-white' : 'text-common-grey'}`
              ]"
              @click="handleTabClick('team_members')">{{ $t("People") }}
            </span>
            <span
              v-if="!hideChannelsTab"
              :class="[` p-2 border rounded-tr-md rounded-br-md  ${active_tab == 'channels' ? 'bg-blue text-white' : 'text-common-grey'}`]"
              @click="handleTabClick('channels')">{{ $t("Channels") }}
            </span>
            <span
              v-if="autocompleteOptions?.filter((option) => !option.dynamic_metric_selection).length"
              :class="[` p-2 border rounded-tr-md rounded-br-md  ${active_tab == 'dynamic' ? 'bg-blue text-white' : 'text-common-grey'}`]"
              @click="handleTabClick('dynamic')">{{ $t("Dynamic") }}
            </span>
            <span
              v-if="autocompleteOptions?.filter((option) => option.dynamic_metric_selection).length"
              :class="[` p-2 border rounded-tr-md rounded-br-md  ${active_tab == 'custom' ? 'bg-blue text-white' : 'text-common-grey'}`]"
              @click="handleTabClick('custom')">{{ $t("Custom") }}
            </span>
          </div>

          <div v-if="active_tab == 'team_members' && !filtered_team_members.length" class="mt-8 ml-2 text-common-grey">
            {{ $t("No team members matching search query") }}
          </div>
          <div
            v-else-if="active_tab == 'dynamic' && !autocompleteOptions.filter((option) => !option.dynamic_metric_selection).length"
            class="mt-8 mb-3 ml-2 text-common-grey">
            {{ $t("No results") }}
          </div>
          <div
            v-else-if="active_tab == 'custom' && !autocompleteOptions.filter((option) => !option.dynamic_metric_selection).length"
            class="mt-8 ml-2 text-common-grey">
            {{ $t("No results") }}
          </div>

          <div v-else-if="active_tab == 'team_members'" class="mt-6">
            <ListboxOption v-for="user in filtered_team_members" :key="user.id" as="template" @click="handleSelect(user)">
              <div
                class="relative py-2 pl-8 pr-4 transition ease-in-out rounded-lg cursor-pointer text-light-body-text hover:bg-light-brand-blue dark:hover:bg-dark-brand-blue duration-side-menu-transition-duration">
                <div class="flex items-center">
                  <img v-if="user.profile.image_72" class="flex-shrink-0 w-6 h-6 rounded-full" :src="user.profile.image_72" alt="">

                  <Logo v-else :animate="true" />
                  <div>
                    <div :class="['font-normal ml-3 block truncate']">
                      {{ user.profile.first_name }}
                    </div>
                    <div class="ml-3 text-light-body-text">
                      {{ user.profile.email }}
                    </div>
                  </div>
                </div>
              </div>
            </ListboxOption>
          </div>
          <div v-else-if="active_tab == 'channels'" class="mt-6">
            <ListboxOption v-for="channel in filtered_channels_list" :key="channel.id" as="template" @click="handleSelect(channel)">
              <div
                class="relative py-2 pl-8 pr-4 transition ease-in-out rounded-lg cursor-pointer text-light-body-text hover:bg-light-brand-blue dark:hover:bg-dark-brand-blue duration-side-menu-transition-duration">
                <div class="flex items-center">
                  <div>
                    <div :class="['font-normal ml-3 block truncate']">
                      {{ channel.name }}
                    </div>
                  </div>
                </div>
              </div>
            </ListboxOption>
          </div>
          <div v-else-if="active_tab == 'dynamic'" class="mt-6">
            <ListboxOption
              v-for="result in autocompleteOptions.filter((a) => (search_term ? a.label.toLowerCase().includes(search_term) : true))"
              :key="result.value"
              as="template"
              @click="handleSelect(result)">
              <div
                class="relative py-2 pl-8 pr-4 transition ease-in-out rounded-lg cursor-pointer text-light-body-text hover:bg-light-brand-blue dark:hover:bg-dark-brand-blue duration-side-menu-transition-duration">
                <div class="flex items-center">
                  <div>
                    <div :class="['font-normal ml-3 block truncate']">
                      {{ result.label }}
                    </div>
                  </div>
                </div>
              </div>
            </ListboxOption>
          </div>

          <div v-else-if="active_tab == 'custom'" class="mt-6">
            <ListboxOption
              v-for="result in autocomplete_options_clone
                .filter((option) => option.dynamic_metric_selection)
                .filter((a) => (search_term ? a.label.toLowerCase().includes(search_term) : true))"
              :key="result.value"
              :class="[{ 'pointer-events-none': !result.value?.email }]"
              as="template"
              @click="
                () => {
                  !result.value?.email ? null : handleSelect(result)
                }
              ">
              <div
                class="relative py-2 pl-8 pr-4 transition ease-in-out rounded-lg cursor-pointer text-light-body-text hover:bg-light-brand-blue dark:hover:bg-dark-brand-blue duration-side-menu-transition-duration">
                <div class="flex items-center w-full">
                  <div>
                    <div :class="['font-normal ml-3 block truncate']">
                      {{ result.label }}
                    </div>
                  </div>

                  <div class="pointer-events-auto" @click.prevent>
                    <div
                      class="btn cancel-btn border-dark-brand-blue text-dark-brand-blue"
                      @click.stop="
                        () => {
                          object_type = result.object_type
                          $emitter.emit(ALL_EMITTERS.MAP_CUSTOM_FIELDS, { record: result, object_type: result.object_type, all_metrics })
                        }
                      ">
                      <span><MapFieldsIcon v-if="!result.value?.email" class="mr-2" /> <PencilLine v-else class="mr-2" color="#2DA7D7" />
                      </span>
                      {{ result.value?.email ? "Edit Mapping" : "Map Fields" }}
                    </div>
                  </div>
                </div>
              </div>
            </ListboxOption>
          </div>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>

<script>
import { Listbox, ListboxOption, ListboxOptions } from "@headlessui/vue"
import { PencilLine, Plus } from "lucide-vue-next"
import Logo from "@/components/shared/Logo.vue"
import json_data from "@/components/shared/json-files/all-obj-fields.json"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import MapFieldsIcon from "@/components/shared/icons/MapFieldsIcon.vue"

export default {
  components: {
    Plus,
    Logo,
    Listbox,
    ListboxOption,
    ListboxOptions,
    MapFieldsIcon,
    PencilLine
  },
  props: {
    hideChannelsTab: null,
    hidePeopleTab: null,
    shortKing: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      required: false,
      default: "Search"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autocompleteOptions: {
      type: Array,
      default: () => [],
      required: false
    }
  },
  emits: ["chosen"],

  data() {
    return {
      ALL_EMITTERS,

      show_results: false,
      search_term: null,
      filtered_team_members: [],
      filtered_channels_list: [],
      active_tab: "team_members",
      forecasted_objects: [],
      other_metrics: [],
      autocomplete_options_clone: [],
      object_type: "company"
    }
  },

  computed: {
    translatedPlaceholder() {
      return this.$t(this.placeholder)
    },
    all_metrics() {
      let forecast_metrics = []
      if (this.forecasted_objects?.includes(this.object_type)) {
        forecast_metrics = [
          {
            reference_name: `forecasts__forecast_status`,
            name: this.$t("Forecast Status"),
            data_type: "String",
            input_type: "Select",
            input_options: { choices: ["forecasted", "actual"] },
            object_type: this.object_type
          },
          {
            reference_name: `forecasts__forecast_type`,
            name: this.$t("Forecast Type"),
            data_type: "String",
            input_type: "Select",
            input_options: { choices: ["non-renewable", "renewable"] },
            object_type: this.object_type
          },
          {
            reference_name: `forecasts__forecast_value`,
            name: this.$t("Forecast Value"),
            data_type: "Number",
            input_type: "Number",
            object_type: this.object_type
          }
        ]
      }
      let owner_co_owner_filer = [
        {
          reference_name: `owner__email`,
          name: this.$t("Owner"),
          data_type: "String",
          input_type: "Text",
          object_type: this.object_type
        },
        {
          reference_name: `co_owners__email`,
          name: this.$t("Co-Owners"),
          data_type: "String",
          input_type: "Text",
          object_type: this.object_type
        }
      ]
      let tags_filter_fields = [
        {
          reference_name: `tags__name`,
          name: this.$t("Assigned tags"),
          data_type: "String",
          input_type: "Text",
          object_type: this.object_type
        }
      ]

      const metrics_calc = this.$store.state.metrics
        .concat(forecast_metrics)
        .concat(owner_co_owner_filer)
        .concat(this.other_metrics)
        .concat(tags_filter_fields)

      let metrics_calc_clean = []

      metrics_calc_clean = metrics_calc.filter(
        (m) =>
          !m.reference_name.includes("owner_email") &&
          !m.reference_name.includes("owner_first_name") &&
          !m.reference_name.includes("owner_last_name") &&
          !m.reference_name.includes("owner_name") &&
          m.data_type !== "Plan" &&
          m.data_type !== "Goal" &&
          m.data_type !== "Task" &&
          m.data_type !== "Interaction" &&
          m.data_type !== "Milestone"
      )

      return metrics_calc_clean
    },
    users_list() {
      if (this.$store.state.integration.integrations.find((i) => i.name == "slack").users?.length) {
        return this.$store.state.integration.integrations.find((i) => i.name == "slack").users
      }
      return []
    },
    channels_list() {
      if (this.$store.state.integration.integrations.find((i) => i.name == "slack").channels) {
        return this.$store.state.integration.integrations.find((i) => i.name == "slack").channels.user
      }

      return []
    }
  },
  watch: {
    search_term() {
      if (this.search_term) {
        if (this.search_term === "," || this.search_term === " ") {
          this.search_term = ""
        }

        this.filtered_team_members = this.users_list.filter((contact) =>
          contact.profile.first_name == "Revsetter"
            ? contact.profile.first_name.toLowerCase().includes(this.search_term.toLowerCase())
            : contact.profile.email?.includes(this.search_term) ||
              contact.profile.first_name.toLowerCase().includes(this.search_term.toLowerCase())
        )
        this.filtered_channels_list = this.channels_list.filter((channel) =>
          channel.name.toLowerCase().includes(this.search_term.toLowerCase())
        )
        this.show_results = true
      } else {
        this.filtered_team_members = this.users_list
        this.filtered_channels_list = this.channels_list
        this.show_results = false
      }
    }
  },

  created() {
    this.filtered_team_members = this.users_list
    this.filtered_channels_list = this.channels_list

    this.init()
  },

  methods: {
    init() {
      this.forecasted_objects = this.$utils
        .find(this.$store.state.settings.modules_settings, {
          reference_code: "renewal_base_metric"
        })
        ?.mapped_objects_metrics?.map((type_map) => {
          return this.$store.state.object_types.find((x) => x.id == type_map.object_type)?.type
        })
      Object.entries(json_data).map((item) => {
        this.other_metrics.push({ ...item[1], object_type: this.object_type })
      })

      this.autocomplete_options_clone = this.$utils.clone(this.autocompleteOptions)
    },

    handleTabClick(tab) {
      this.show_results = true
      this.active_tab = tab
    },
    handleSelect(item) {
      const item_clone = this.$utils.clone(item)
      if (item_clone?.label && item_clone?.value) {
        // item_clone["id"] = item_clone.value
        item_clone["name"] = item_clone.label
        this.$emit("chosen", { item: item_clone, type: "team_members" })
      } else {
        this.$emit("chosen", { item: item_clone, type: this.active_tab })
      }
      this.search_term = null
      this.show_results = false
    }
  }
}
</script>

<style scoped>
.mh-48 {
  max-height: 10rem;
}
</style>
